import React from 'react';
import { Box, SpaceBetween } from '@amzn/awsui-components-core';
import supplementalContextExample from '../../assets/supplemental-context-example.png';
import './SupplementalContextGuide.scss';

/**
 * "How to Add Supplemental Context" guide shown inline under the "Supplemental Context" row of the
 * Step 3 Folder Guide. Presentation-only: a bulleted list of bold-labeled points (What it is / How
 * it's organized / How to add files / Accepted formats) and a width-capped example screenshot of
 * the folder tree. Rendered flat (no collapsible) to match the reference layout. Sibling of
 * ManagerHubRatingsGuide.
 */
export const SupplementalContextGuide: React.FC = () => (
  // Class-bearing div (not the deprecated `className` prop) so the scoped SCSS can size the list
  // markers and the example image.
  <div className="supplemental-context-guide">
    <SpaceBetween size="s">
      <ul className="supplemental-context-guide__bullets">
        <li>
          <Box variant="strong">What it is:</Box> Extra material per person — self-reviews, project documents, recognition — that gives the AI more
          signal beyond ratings alone.
        </li>
        <li>
          <Box variant="strong">How it&apos;s organized:</Box> One subfolder per employee, named by alias (e.g., <Box variant="strong">weivwang</Box>,{' '}
          <Box variant="strong">saurabhi</Box>, <Box variant="strong">ndivine</Box>).
        </li>
        <li>
          <Box variant="strong">How to add files:</Box> Upload each person&apos;s documents into the subfolder matching their alias. Multiple files
          per person are fine. Do not mix one person&apos;s files into another person&apos;s subfolder.
        </li>
        <li>
          <Box variant="strong">Accepted formats:</Box> DOC, DOCX, PDF, PNG, JPEG, JPG, XLSX
        </li>
      </ul>

      <img
        className="supplemental-context-guide__image"
        src={supplementalContextExample}
        alt="Example: the Supplemental Context folder with one subfolder per employee alias, such as weivwang, saurabhi, and ndivine"
      />
    </SpaceBetween>
  </div>
);
